import addCustomUserAgentHeader from 'utils/addCustomUserAgentHeader';
import baseFetch, { createParamString } from '../baseFetch';

interface FetchArticleByIdParams {
  id: string | undefined;
  geotarget: string;
  preview?: boolean | null;
  cookies?: Record<string, unknown>;
  isServer?: boolean;
}

interface FetchTaxonomyDetailsParams {
  taxonomy: string;
  term?: string | null;
  geotarget: string;
  limit?: number | null;
  offset?: number | null;
  isServer?: boolean;
}

interface FetchTaxonomyPostsParams {
  taxonomy: string;
  term?: string | null;
  geotarget: string;
  limit?: string | null;
  offset?: string | null;
  isServer?: boolean;
}

export const fetchEditorialArticleById = ({
  id,
  geotarget: _geotarget,
  preview = null,
  cookies,
  isServer = false,
}: FetchArticleByIdParams) => {
  const opts: {
    credentials?: RequestCredentials;
  } = {};
  const articleId = id?.toString() || '';

  let url = `/feed/article/${articleId}`;
  const params: Record<string, string> = {};
  if (preview) {
    params.preview = 'true';
    // Only use credentials: 'include' on client-side; server-side uses explicit cookies
    if (!isServer) {
      opts.credentials = 'include';
    }
  }
  // Feed article endpoint does not support geotarget; region content is resolved from article fields.
  if (Object.keys(params).length > 0) {
    url += `?${createParamString(params)}`;
  }

  return baseFetch(url, { ...opts, cookies, headers: { ...addCustomUserAgentHeader(isServer) } });
};

export const fetchEditorialTaxonomyDetails = ({
  taxonomy,
  term,
  geotarget,
  limit,
  offset,
  isServer = false,
}: FetchTaxonomyDetailsParams) => {
  const opts = {
    headers: { ...addCustomUserAgentHeader(isServer) },
  };

  let url = `/feed/taxonomy/${taxonomy}/details`;
  if (term) url += `/${term}`;

  const params: Record<string, string> = {};
  if (geotarget) params.geotarget = geotarget;
  if (limit != null) params.limit = String(limit);
  if (offset != null) params.offset = String(offset);
  if (Object.keys(params).length > 0) {
    url += `?${createParamString(params)}`;
  }

  return baseFetch(url, opts);
};

export const fetchEditorialTaxonomyPosts = ({
  taxonomy,
  term,
  geotarget,
  limit,
  offset,
  isServer = false,
}: FetchTaxonomyPostsParams) => {
  const opts = {
    headers: { ...addCustomUserAgentHeader(isServer) },
  };

  let url = `/feed/taxonomy/${taxonomy}/posts`;
  if (term) url += `/${term}`;

  const params: Record<string, string> = {};
  if (geotarget) params.geotarget = geotarget;
  if (limit) params.limit = limit;
  if (offset) params.offset = offset;
  return baseFetch(`${url}?${createParamString(params)}`, opts);
};
